import { createBrowserRouter, Navigate } from 'react-router-dom';
import Routes from './Routes.ts';
import LoginPage from '@/pages/LoginPage.tsx';
import SandboxPage from '@/pages/SandboxPage.tsx';
import { transformRouterConfig } from '@/router/transformRouter.tsx';
import RegisterPage from '@/pages/RegisterPage.tsx';
import Default from '@/layouts/Default/Default.tsx';
import Admin from '@/layouts/Admin/Admin.tsx';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage.tsx';
import ResetPasswordPage from '@/pages/ResetPasswordPage.tsx';
import HomePage from '@/pages/HomePage.tsx';
import SimpleCenter from '@/layouts/SimpleCenter/SimpleCenter.tsx';
import ConfirmEmailPage from '@/pages/ConfirmEmailPage.tsx';
import PaymentSelectPage from '@/pages/PaymentSelectPage.tsx';
import DataTablePage from '@/pages/DataTablePage.tsx';
import InputsPage from '@/pages/InputsPage.tsx';
import { LayoutInternal } from '$/views/emails/layout.tsx';
import LessonDetailsPage from '@/pages/LessonDetailsPage.tsx';
import QuizPage from '@/pages/QuizPage.tsx';
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage.tsx';
import AdminUsersPage from '@/pages/admin/AdminUsersPage.tsx';
import AdminLessonsPage from '@/pages/admin/AdminLessonsPage.tsx';
import AdminAnalyticsPage from '@/pages/admin/AdminAnalyticsPage.tsx';
import AdminUploadContentPage from '@/pages/admin/AdminUploadContentPage.tsx';
import AdminUploadLessonPage from '@/pages/admin/AdminUploadLessonPage.tsx';
import AdminAddRegionPage from '@/pages/admin/AdminAddRegionPage.tsx';

const router = createBrowserRouter(
  transformRouterConfig([
    {
      path: '/',
      element: <Default.Layout />,
      middleware: ['loggedIn', 'userOnly'],
      children: [
        {
          path: Routes.DASHBOARD,
          element: <HomePage />,
        },
        {
          path: Routes.LESSON_DETAILS,
          element: <LessonDetailsPage />,
        },
        {
          path: Routes.SANDBOX,
          element: <SandboxPage />,
        },
        {
          path: Routes.DATA_TABLE,
          element: <DataTablePage />,
        },
        {
          path: Routes.INPUTS,
          element: <InputsPage />,
        },
      ],
    },
    {
      path: Routes.QUIZ,
      element: <Default.Layout showLogo={false} showSearch={false} />,
      middleware: ['loggedIn'],
      children: [
        {
          path: '',
          element: <QuizPage />,
        },
      ],
    },
    {
      path: '/',
      element: <SimpleCenter />,
      middleware: ['notLoggedIn'],
      children: [
        {
          path: Routes.FORGOT_PASSWORD,
          element: <ForgotPasswordPage />,
        },
        {
          path: Routes.LOGIN,
          element: <LoginPage />,
        },
        {
          path: Routes.REGISTER,
          element: <RegisterPage />,
        },
        {
          path: Routes.CONFIRM_EMAIL,
          element: <ConfirmEmailPage />,
        },
      ],
    },
    // SimpleCenter layout
    {
      path: '/',
      element: <SimpleCenter />,
      children: [
        {
          path: Routes.RESET_PASSWORD,
          element: <ResetPasswordPage />,
        },
      ],
    },
    // SimpleCenter logged in
    {
      path: '/',
      element: <SimpleCenter />,
      middleware: ['loggedIn', 'userOnly'],
      children: [
        {
          path: Routes.PAYMENT_SELECT,
          element: <PaymentSelectPage />,
        },
      ],
    },
    {
      path: Routes.EMAIL_TEMPLATE,
      element: (
        <LayoutInternal
          appUrl={import.meta.env.VITE_APP_URL}
          appName={'app-name'}
          logo={`${import.meta.env.VITE_APP_URL}/assets/logo.png`}
        >
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab animi atque possimus, quaerat quasi tempore
          totam! Architecto assumenda cumque deleniti dolor expedita facilis illo minima nihil quidem soluta? Hic,
          laboriosam!
        </LayoutInternal>
      ),
    },
    // Admin routes with navbar
    {
      path: '/admin',
      element: <Admin.Layout />,
      middleware: ['loggedIn', 'adminOnly'],
      children: [
        {
          path: Routes.ADMIN_DASHBOARD,
          element: <AdminDashboardPage />,
        },
        {
          path: Routes.ADMIN_USERS,
          element: <AdminUsersPage />,
        },
        {
          path: Routes.ADMIN_LESSONS,
          element: <AdminLessonsPage />,
        },
        {
          path: Routes.ADMIN_ANALYTICS,
          element: <AdminAnalyticsPage />,
        },
      ],
    },
    // Admin routes without navbar
    {
      path: '/admin',
      element: <Admin.Layout showLogo={false} showSearch={false} />,
      middleware: ['loggedIn', 'adminOnly'],
      children: [
        {
          path: Routes.ADMIN_ADD_REGION,
          element: <AdminAddRegionPage />,
        },
        {
          path: Routes.ADMIN_UPLOAD_CONTENT,
          element: <AdminUploadContentPage />,
        },
        {
          path: Routes.ADMIN_UPLOAD_LESSON,
          element: <AdminUploadLessonPage />,
        },
        {
          path: Routes.ADMIN_EDIT_LESSON,
          element: <AdminUploadLessonPage />,
        },
        {
          path: Routes.ADMIN_LESSON_DETAILS,
          element: <LessonDetailsPage />,
        },
        {
          path: Routes.ADMIN_QUIZ,
          element: <QuizPage />,
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to={Routes.DASHBOARD} />,
    },
  ])
);

export default router;
